import { create } from "zustand";
import { RolePermissions } from "../models/role";

export const useRolePermissionsStore = create((set) => ({
  rolePermissions: null,
  setRolePermissions: (rolePermissions: RolePermissions) =>
    set({ rolePermissions: rolePermissions }),
}));
